import { managerColor } from "../lib/colors";

/**
 * Per-manager identity chip: a circular portrait with a brand-color ring + glow.
 * Falls back to a monogram in the manager's color when no portrait is supplied,
 * so it works today and lights up automatically once art lands in public/managers.
 */
export function ManagerAvatar({
  name,
  seed,
  src,
  size = 40,
  ring = true,
}: {
  name: string;
  seed: number;
  src?: string | null;
  size?: number;
  ring?: boolean;
}) {
  const color = managerColor(seed);
  const px = `${size}px`;
  return (
    <span
      className="relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-ink-800 font-bold uppercase leading-none text-fg"
      style={{
        width: px,
        height: px,
        fontSize: `${Math.round(size * 0.42)}px`,
        boxShadow: ring ? `0 0 0 2px ${color}, 0 0 14px ${color}66` : undefined,
      }}
      aria-label={name}
    >
      {src ? (
        <img src={src} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span style={{ color }}>{name.charAt(0)}</span>
      )}
    </span>
  );
}
